import { useState, useEffect } from 'react';
import _get from 'lodash/get';
import _map from 'lodash/map';
import isNil from 'lodash/isNil';

import { UserV2 } from 'models/settingsV2.model';
import { RegistrationFilters } from './constants';
import useService from './useService';

const useUser = () => {
	const { getRegisteredUser } = useService();
	const [userData, setUserData] = useState<any>({ data: [], rowCount: 0 });
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [filters, setFilters] = useState<RegistrationFilters | undefined>(undefined);
	const [showLoader, setShowLoader] = useState<boolean>(false);

	const fetchUserData = async () => {
		try {
			setShowLoader(true);
			const result = await getRegisteredUser(filters || {});

			const formattedData: Array<UserV2> = _map(_get(result, 'data'), (row: UserV2) => {
				const newRow = { ...(row || {}) };
				return newRow;
			});
			setUserData({ data: formattedData, rowCount: result?.rowCount });
			setForceUpdate(true);
		} catch (error: any) {
			setUserData({ data: [], rowCount: 0 });
			setForceUpdate(true);
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		if (!isNil(filters)) {
			fetchUserData();
		}
	}, [filters]);

	const getUserData = () => {
		setForceUpdate(false);
		return userData;
	};

	const handleFilterSubmit = (submittedFilters: RegistrationFilters) => {
		setFilters(submittedFilters);
	};

	return { getUserData, handleFilterSubmit, forceUpdate, showLoader };
};

export default useUser;
